import { render } from "./Auth.vue?vue&type=template&id=472c995a&scoped=true"
import script from "./Auth.vue?vue&type=script&lang=js"
export * from "./Auth.vue?vue&type=script&lang=js"

import "./Auth.vue?vue&type=style&index=0&id=472c995a&lang=scss&scoped=true"

import exportComponent from "D:\\ProjectsWeb\\road-maintenance-launcher\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-472c995a"]])

export default __exports__